const valueToVerticalPixel = (value, cardMin, cardMax, canvasHeight) => {
  //return (450 / (cardMin - cardMax)) * (value - cardMax) + 25;
  return (
    ((0.9 * canvasHeight) / (cardMin - cardMax)) * (value - cardMax) +
    0.05 * canvasHeight
  );
};

export default valueToVerticalPixel;
